import { makeStyles, Theme } from '@material-ui/core';

export default makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    // justifyContent: 'space-between',
    padding: '2rem',
    backgroundColor: theme.palette.background.light,
    flexDirection: 'column',
    height: '100%',
  },
  button: {
    minWidth: '215px',
  },
  activeButton: {
    minWidth: '215px',
  },
  btnDiv: {
    display: 'flex',
    width: '100%',
    marginTop: theme.spacing(2),
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    flexGrow: 1,
  },
  titleImg: {
    height: '120px',
    textAlign: 'center',
  },
}));
